/**
 * @class Port
 */

import * as React from "react";
import { IPort } from "./interfaces/ComponentDefinition";
import { Wedge, Text } from "react-konva";
import { Text as KonvaText } from "konva";

export type Props = {
  port: IPort;
  angle: number;
  idx: number;
  onHover(port: IPort): void;
  visible: boolean;
};

type State = {
  hovering: boolean;
};

export default class Port extends React.Component<Props, State> {
  text: any;
  state = {
    hovering: false
  };

  onHoverChange = (hovering: boolean) => {
    this.setState({ hovering });
  };

  onText = (text: any) => {
    if (!this.text) {
      this.text = text;
      const height = (this.text as KonvaText).getHeight();
      (this.text as KonvaText).offsetY(height / 2);
      (this.text as KonvaText).moveToTop();
    }
  };
  render() {
    const { port, angle, idx, onHover, visible } = this.props;
    const rotation = -90 + angle * idx;
    const radius = 38;

    return (
      <React.Fragment>
        <Wedge
          angle={angle}
          radius={radius}
          fill={port.color}
          rotation={rotation}
          visible={visible}
          onMouseOver={ev => {
            this.onHoverChange(true);
            ev.cancelBubble = true;
            onHover(port);
          }}
          onMouseOut={() => this.onHoverChange(false)}
          onDragMove={ev => {
            ev.cancelBubble = true;
          }}
          onDragStart={ev => {
            ev.cancelBubble = true;
          }}
        />
      </React.Fragment>
    );
  }
}
